import { Link } from "react-router-dom";
import { Download, FileJson, FileText } from "lucide-react";
import { RunsList } from "@/components/organisms/reports/RunsList";

export function StudioDocsPage() {
  return (
    <div className="space-y-6">
      <section className="studio-hero">
        <div>
          <div className="studio-eyebrow">Documentation - artifacts</div>
          <h1 className="studio-title">
            Documentation <em>from real runs.</em>
          </h1>
          <p className="studio-subtitle">
            Find generated Markdown, HTML, JSON, and PDF artifacts from playbook and agent executions.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link to="/migrations" className="studio-button">
            <FileText className="h-4 w-4" />
            Generate docs
          </Link>
          <Link to="/runs" className="studio-button studio-button-primary">
            <Download className="h-4 w-4" />
            Download artifacts
          </Link>
        </div>
      </section>

      <div className="grid gap-4 md:grid-cols-4">
        {["Markdown", "HTML", "JSON", "PDF"].map((name) => (
          <div key={name} className="studio-card p-4">
            <FileJson className="mb-3 h-4 w-4 text-muted-foreground" />
            <div className="font-semibold">{name}</div>
            <p className="mt-1 text-sm text-muted-foreground">Generated after successful runs.</p>
          </div>
        ))}
      </div>

      <RunsList />
    </div>
  );
}
